import React, {  useState,useEffect } from "react";
import GetMonthsOpt from "../../Dropdowns/getSelectMonth.js";
import GetYearsOpt from "../../Dropdowns/getSelectYear.js";
import ICDSSalesReport from "./ICDSSalesDistrictReport.jsx";


const ICDSSaleInt = () => {

    const [loading, setLoading] = useState(true);
    const [renderContent, setRenderContent] = useState(null);
    const [autoSubmitted, setAutoSubmitted] = useState(false);


    const handleMonthsLoadingChange = (isLoading) => {
      handleLoadingChange(isLoading);
    };

    const handleLoadingChange = (isLoading) => {
      setLoading(isLoading);
    };

    const handleYearsLoadingChange = (isLoading) => {
      handleLoadingChange(isLoading);
    };

    useEffect(() => {
    const interval = setInterval(() => {
    if (autoSubmitted) return;

    const month = document.getElementById("month");
    const year = document.getElementById("year");
    const allotMonth = document.getElementById("allot_month");
    const allotYear = document.getElementById("allot_year");

    const allReady =
      month?.options?.length > 0 &&
      year?.options?.length > 0 &&
      allotMonth?.options?.length > 0 &&
      allotYear?.options?.length > 0 &&
      month.value &&
      year.value &&
      allotMonth.value &&
      allotYear.value;

    if (allReady) {
      setAutoSubmitted(true);
      clearInterval(interval);
      handleSubmit();
    }
  }, 300); // check every 300ms

  return () => clearInterval(interval);
}, [autoSubmitted]);

 


    const handleSubmit = async () => {

    const month = document.getElementById("month").value;
    const year = document.getElementById("year").value;
    const allot_month = document.getElementById("allot_month").value;
    const allot_year = document.getElementById("allot_year").value;
    const alotMonthName = document.getElementById("allot_month").options[document.getElementById("allot_month").selectedIndex].text;
    const distMonthName = document.getElementById("month").options[document.getElementById("month").selectedIndex].text;    

     if (month == null || month == "") {
      alert("Please select Distribution Month");
      return false;
    } else if (year == null || year == "")
    {
      alert("Please select Distribution Year");
      return false;
    }
    if (allot_month == null || allot_month == "") {
      alert("Please select Allotment Month");
      return false;
    } else if (allot_year == null || allot_year == "")
    {
      alert("Please select Allotment Year");
      return false;
    } 
    else
    {
      setRenderContent(null);
      setRenderContent(
          <ICDSSalesReport
            month={month}
            year={year} 
            allotMonth={allot_month}
            allotYear={allot_year}         
            distMonthName={distMonthName}  
            alotMonthName={alotMonthName}         
          />
        );
    }  
       
    }


    return (
      <>
      <div
        className="wrapper row3"
        style={{ maxHeight: "95vh", paddingBottom: "40px" }}
      >
        {" "}
      </div>

       <div id="container">
       <div style={{
                display: "flex",
                justifyContent: "center",
                marginBottom: "10px",
            }}
            >

            <table width="65%">
            <thead>
                <tr className="tableheader">
                    <th colSpan={8}>Commodity wise ICDS Sales</th>
                </tr>
            </thead>
            <tbody>

            <tr>
                <td>Distribution Month :</td>
                <td>
                  <GetMonthsOpt
                    input_id="month"
                    onLoadingChange={handleMonthsLoadingChange}
                  />
                </td>
                <td>Distribution Year:</td>
                <td>
                  <GetYearsOpt
                    input_id="year"
                    onLoadingChange={handleYearsLoadingChange}
                  />
                </td>
                <td>Allotted Month :</td>
                  <td>
                    <GetMonthsOpt
                      input_id="allot_month"
                      onLoadingChange={handleMonthsLoadingChange}
                    />
                  </td>
                  <td>Allotted Year:</td>
                  <td>
                    <GetYearsOpt
                      input_id="allot_year"
                      onLoadingChange={handleYearsLoadingChange}
                    />
                  </td>
                </tr>
                <tr>
                  <td colSpan="10" align="center">
                    {
                      <button
                        className="button button2"
                        style={{ marginRight: "10px" }}
                        onClick={handleSubmit}
                      >
                        Submit
                      </button>
                    }
                    <button
                      className="button button2"
                      onClick={() => window.history.back()}
                    >
                      Back
                    </button>
                  </td>
              </tr>

            </tbody>
        </table>       
        </div>
        <div id="loading" style={{ display: "none", textAlign: "center" }}>
          <img src="images/progress.gif" alt="Loading" />
        </div>
        <br />
        <div id="icdsSalesDistrictReport">{renderContent}</div>   
        </div>        
        </>
    );

}


export default ICDSSaleInt;